import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { Button } from 'reactstrap'
import { Modal, ModalBody, Form, ModalHeader, FormGroup, Label, Input } from 'reactstrap'
import { BROWSER_INFO } from '../../utils/detectBrowser'

class SupportModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      response_ok: false,
      error: false
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    mutate: PropTypes.func.isRequired,
    screenShotFileData: PropTypes.string.isRequired
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({ submitted: true })

    const form_elements = event.target.elements
    this.props.mutate({
      variables: {
        url: window.location.href,
        description: form_elements.description.value,
        browser: BROWSER_INFO,
        resolution: `${window.innerWidth} x ${window.innerHeight}`,
        file_data: this.props.screenShotFileData
      },
    }).then(({ data: { sendSupportEmail } }) => {
      if (sendSupportEmail.response === 'ok') {
        this.setState({ response_ok: true })
        setTimeout(() => {
          this.props.onCancel()
        }, 2000)
      }
    }).catch((error) => {
      this.setState({ submitted: false, error: true })
    })
  }

  render() {
    return (
      <Modal isOpen={true} style={{ zIndex: '1070' }}>
        <ModalHeader>Send message to weldinGo Support</ModalHeader>
        <ModalBody>
          {this.state.response_ok ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#4dbd74'
            }}>
              <i className="fa fa-check-circle" style={{ fontSize: '60px', marginBottom: '20px' }} />
              <h4 style={{ color: '#4dbd74', marginBottom: '15px' }}>Thank you!</h4>
              <p style={{ fontSize: '16px', color: '#666' }}>
                Thank you for submitting the report. Our operators will contact you immediately.
              </p>
            </div>
          ) : (
            <Form id="support-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label for="description-support-form">Issue Description</Label>
                <Input required type="textarea" rows="10" name="description" id="description-support-form" />
                {this.state.error && <div className="text-danger">
                  <p>Failed to send the form. Please contact us via email at support@weldingo.com</p>
                </div>}
              </FormGroup>

              <hr />
              <Button id="cancel-support-form-btn" className="float-right" color="danger"
                onClick={this.props.onCancel}>Cancel</Button>
              {!this.state.submitted && !this.state.error &&
                <Button id="send-support-form-btn" className="float-right" color="primary" type="submit">Send</Button>}
              {this.state.error &&
                <Button id="retry-support-form-btn" className="float-right" color="primary" type="submit">Retry</Button>}
            </Form>
          )}
        </ModalBody>
      </Modal>
    )
  }
}

const sendSupportEmailMutation = gql`
  mutation sendSupportEmailMutation($url: String!, $description: String, $browser: String, $resolution: String, $file_data: String) {
    sendSupportEmail(url: $url, description: $description, browser: $browser, resolution: $resolution, file_data: $file_data) {
      response
    }
  }
`

const SupportModalWithMutation = graphql(sendSupportEmailMutation)(SupportModal)

export default SupportModalWithMutation



// WEBPACK FOOTER //
// ./src/components/Support/SupportModal.js